import React, { useRef } from 'react'
import { TextField } from '@the-platform-group/component-library'
import { useModalContext } from '@the-platform-group/component-library/Modal/ModalContext'
import useImportUser from './useAddUser'

/**
 * Provides a handler to open an "Add FDS User" modal via ModalContext.
 * The modal contains a factset username serial number input; on save it calls importUser.
 * @returns {object} - { openAddUserModal }
 */
function useAddUserModal() {
  const { handleOpenModal, handleCloseModal, updateModalState } = useModalContext()
  const { importUser } = useImportUser()
  const serialNumberRef = useRef('')

  const openAddUserModal = () => {
    serialNumberRef.current = ''

    handleOpenModal({
      title: 'Add User',
      content: (
        <TextField
          label="FactSet Username Serial Number"
          onChange={e => {
            serialNumberRef.current = e.target.value
          }}
          fullWidth
          autoFocus
        />
      ),
      actionProps: {
        saveButtonText: 'Save',
        handleSave: () => {
          const value = serialNumberRef.current.trim()
          updateModalState({ isLoading: true })
          importUser(value, {
            onSuccess: () => {
              handleCloseModal()
            },
            onSettled: () => {
              updateModalState({ isLoading: false })
            },
          })
        },
      },
    })
  }

  return { openAddUserModal }
}

export default useAddUserModal
